import React, { useState } from 'react'
import FormBuilder from '../components/FormBuilder'
import { useMyContext } from '../context/context'
import useSettingsV2 from '../hooks/useSettingsV2'
import Flex from '../shared/Flex'
import HTML from '../components/HTML'

function SatisfactionForm() {
  const { user } = useMyContext()
  const { settings: settingsV2 } = useSettingsV2()

  const [isSaved, setIsSaved] = useState(false)

  return (
    <>
      <HTML name="satisfactionHtml" />
      {!isSaved && user && settingsV2?.FO_MEETING_SATISFACTION_FORM_ID && (
        <FormBuilder formIdDefault={settingsV2.FO_MEETING_SATISFACTION_FORM_ID} userId={user.id} onFinish={() => setIsSaved(true)} />
      )}
      {isSaved && (
        <Flex>
          <article className="message is-success field">
            <div className="message-body">Votre réponse a bien été prise en compte</div>
          </article>
        </Flex>
      )}
    </>
  )
}

export default SatisfactionForm
